<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-ptwist">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container container-lg shape-container d-flex pt-250 pb-250">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">404
                  <span>Page Not Found</span>
                </h1>
                <p class="lead text-white">This page cannot be found on our website.</p>
                <div class="btn-wrapper">
                  <router-link to="/" title="Home">
                    <base-button class="mr-2 mb-3 mb-sm-0"
                                 type="white">
                      Go back home
                    </base-button>
                  </router-link>
                </div>
              </div>
              <div class="col-lg-6">
                <span class="d-flex align-items-center justify-content-center" style="color: #FFFFFF; font-size:250px;">
                  <font-awesome-icon class="" :icon="{ prefix: 'fas', iconName: 'times-circle' }"/>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
export default {}
</script>
